var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Func4PrintHeader'),_vm._l((_vm.redeCredenciada),function(credenciados){return [(credenciados.credenciados && credenciados.credenciados.length)?_c('Func4PrintGroup',{key:credenciados.codigo_secao,attrs:{"credenciados":credenciados.credenciados,"nome":credenciados.descricao_secao}}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }